module.exports = __webpack_public_path__ + "img/pcc_logo_black.e99ed595.svg";